var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonsterHandsUp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 147,
    viewBox: "0 0 173 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14011_164660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.475 88.3169C166.438 89.1445 166.548 90.5968 165.719 91.561C164.891 92.5243 163.437 92.6346 162.474 91.807C161.512 90.9795 161.404 89.5261 162.232 88.5628C163.061 87.5986 164.513 87.4894 165.475 88.3169Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.189 83.7923C166.151 84.6198 166.259 86.0732 165.431 87.0365C164.602 88.0008 163.15 88.11 162.188 87.2825C161.225 86.4549 161.115 85.0026 161.944 84.0384C162.772 83.075 164.226 82.9648 165.189 83.7923Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.622 80.0601C163.585 80.8884 163.693 82.3418 162.866 83.3042C162.036 84.2693 160.584 84.3785 159.621 83.5502C158.658 82.7227 158.548 81.2703 159.378 80.3052C160.205 79.3428 161.659 79.2326 162.622 80.0601Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.844 85.9988C165.181 90.5931 162.54 95.4075 157.944 96.7512C153.35 98.0928 135.554 99.2486 134.216 94.652C132.877 90.0569 148.506 81.4504 153.101 80.1085C157.697 78.7662 162.507 81.4045 163.844 85.9988Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.977 86.6363C162.061 90.3604 159.922 94.2621 156.196 95.3512C152.473 96.4384 138.047 97.3737 136.964 93.6482C135.879 89.9259 148.546 82.9487 152.269 81.8615C155.993 80.7743 159.891 82.9117 160.977 86.6363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.64 7.35818C163.951 6.29254 162.526 5.98706 161.458 6.67793C160.39 7.36879 160.086 8.79321 160.776 9.85885C161.465 10.9245 162.889 11.2296 163.956 10.5387C165.024 9.84788 165.33 8.42381 164.64 7.35818Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.085 8.25464C168.396 7.189 166.971 6.88516 165.904 7.57537C164.836 8.26623 164.531 9.68965 165.221 10.7553C165.911 11.8209 167.335 12.1271 168.402 11.4362C169.469 10.746 169.775 9.32028 169.085 8.25464Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.434 11.3042C171.744 10.2386 170.322 9.93278 169.254 10.6236C168.187 11.3145 167.882 12.7379 168.571 13.8035C169.261 14.8692 170.685 15.1753 171.753 14.4845C172.82 13.7936 173.123 12.3698 172.434 11.3042Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.529 9.67817C162.053 7.94926 154.117 15.7227 148.809 27.0424C143.498 38.3612 127.815 80.9377 132.292 82.6703C136.767 84.4052 159.708 44.6342 165.018 33.3149C170.327 21.9957 171.004 11.4131 166.529 9.67817Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.731 11.8323C162.102 10.431 155.185 17.7689 150.279 28.2231C145.374 38.6818 130.472 77.8623 134.101 79.2636C137.728 80.6676 158.512 43.7673 163.419 33.3094C168.322 22.8539 169.358 13.2363 165.731 11.8323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18072 6.35818C8.87029 5.29254 10.2953 4.98706 11.3629 5.67793C12.4306 6.36879 12.7347 7.79321 12.0452 8.85885C11.3556 9.92448 9.93224 10.2296 8.86461 9.53874C7.79697 8.84788 7.49115 7.42381 8.18072 6.35818Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73532 7.25464C4.4249 6.189 5.85024 5.88516 6.91687 6.57537C7.9845 7.26623 8.28931 8.68965 7.59974 9.75529C6.91017 10.8209 5.48617 11.1271 4.41854 10.4362C3.35192 9.74598 3.04575 8.32028 3.73532 7.25464Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.387058 10.3042C1.07663 9.23856 2.49898 8.93278 3.5666 9.62364C4.63423 10.3145 4.93904 11.7379 4.24947 12.8035C3.55989 13.8692 2.1359 14.1753 1.06828 13.4845C0.000653332 12.7936 -0.302513 11.3698 0.387058 10.3042Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29178 8.67817C10.7681 6.94926 18.7039 14.7227 24.0121 26.0424C29.3226 37.3612 45.0062 79.9377 40.529 81.6703C36.0542 83.4052 13.1124 43.6342 7.80308 32.3149C2.49375 20.9957 1.817 10.4131 6.29178 8.67817Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.08949 10.8323C10.7193 9.43099 17.6358 16.7689 22.5422 27.2231C27.4467 37.6818 42.3493 76.8623 38.7195 78.2636C35.0924 79.6676 14.309 42.7673 9.40221 32.3094C4.49915 21.8539 3.46234 12.2363 7.08949 10.8323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98173 89.9332C7.03581 90.7795 6.95525 92.2358 7.80117 93.1821C8.64867 94.1302 10.1034 94.2112 11.0494 93.3649C11.9953 92.5185 12.0758 91.0639 11.2282 90.1158C10.3823 89.1695 8.92765 89.0868 7.98173 89.9332Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.182 85.4047C7.23608 86.251 7.15561 87.7057 8.00311 88.6537C8.84982 89.6009 10.3021 89.6809 11.2481 88.8346C12.194 87.9882 12.2769 86.5346 11.4302 85.5874C10.5827 84.6393 9.12793 84.5583 8.182 85.4047Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6737 81.6224C9.72779 82.4688 9.64653 83.9226 10.494 84.8706C11.3407 85.8178 12.7954 85.9005 13.7414 85.0541C14.6873 84.2078 14.7678 82.7515 13.9211 81.8043C13.0736 80.8562 11.6196 80.7761 10.6737 81.6224Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56754 87.5831C8.31931 92.2012 11.0534 96.9643 15.6743 98.2166C20.2938 99.4698 38.1093 100.278 39.3573 95.6563C40.6062 91.036 24.8135 82.7363 20.1926 81.484C15.5708 80.2302 10.8141 82.9621 9.56754 87.5831Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.4472 88.1642C11.435 91.9084 13.6513 95.7681 17.3951 96.7827C21.1401 97.7975 35.5819 98.4534 36.5922 94.7075C37.6033 90.963 24.8034 84.2351 21.0596 83.2205C17.3138 82.2042 13.4586 84.4185 12.4472 88.1642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.111 133.515C142.066 140.066 137.525 146.151 130.968 147.102C124.411 148.056 103.393 145.687 102.438 139.136C101.482 132.587 120.953 124.331 127.512 123.378C134.067 122.426 140.157 126.964 141.111 133.515Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M138.586 132.736C139.391 138.252 135.568 143.372 130.048 144.175C124.532 144.978 106.837 142.984 106.03 137.468C105.23 131.955 121.622 125.006 127.14 124.204C132.658 123.403 137.78 127.222 138.586 132.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.741 142.244C115.627 138.575 124.687 132.051 131.684 123.487C130.37 123.225 128.992 123.175 127.593 123.379C127.419 123.405 127.236 123.436 127.044 123.47C120.844 131.199 112.68 137.004 102.796 140.065C103.162 140.86 103.836 141.586 104.741 142.244Z",
    fill: "#0076AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0799 133.517C30.1248 140.068 34.6659 146.152 41.2211 147.104C47.7773 148.057 68.7974 145.689 69.7536 139.137C70.7097 132.587 51.236 124.331 44.6798 123.379C38.1258 122.427 32.0361 126.965 31.0799 133.517Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.6058 132.736C32.8016 138.252 36.6222 143.372 42.1423 144.174C47.6599 144.977 65.3553 142.985 66.1596 137.468C66.9624 131.954 50.5719 125.006 45.0542 124.204C39.5351 123.402 34.41 127.221 33.6058 132.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.448 142.244C56.5628 138.575 47.5043 132.051 40.5078 123.487C41.8199 123.225 43.1985 123.175 44.5985 123.379C44.772 123.405 44.9551 123.436 45.1452 123.47C51.3478 131.199 59.509 137.004 69.3959 140.065C69.0298 140.86 68.3536 141.586 67.448 142.244Z",
    fill: "#0076AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.338 22.1828C155.167 29.4626 153.179 39.2756 145.893 44.1006C138.61 48.9237 116.211 55.262 111.382 47.9812C106.548 40.704 121.114 22.562 128.399 17.7393C135.685 12.9126 145.506 14.9039 150.338 22.1828Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.15 28.0404C151.301 33.6886 149.278 40.82 143.623 43.9686C137.974 47.1166 128.847 47.8465 125.695 42.1989C122.54 36.5489 126.555 26.6641 132.206 23.5138C137.861 20.3659 144.996 22.3924 148.15 28.0404Z",
    fill: "#0076AA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M139.815 34.5608C141.669 37.7921 139.535 42.4904 135.05 45.0569C130.568 47.6227 125.433 47.0845 123.579 43.8559C121.726 40.624 123.858 35.9258 128.341 33.3589C132.827 30.794 137.961 31.3312 139.815 34.5608Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.017 22.1832C17.186 29.4632 19.1745 39.2762 26.461 44.1005C33.7439 48.9237 56.141 55.2621 60.971 47.9814C65.8027 40.7047 51.2373 22.5623 43.9527 17.7393C36.6685 12.9138 26.8473 14.9041 22.017 22.1832Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2022 28.04C21.0495 33.6887 23.0753 40.8203 28.7284 43.9675C34.3793 47.116 43.5059 47.8457 46.658 42.198C49.8107 36.5493 45.7971 26.6632 40.1459 23.5131C34.4927 20.3659 27.3543 22.3923 24.2022 28.04Z",
    fill: "#0076AA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.538 34.5605C30.6854 37.7924 32.8185 42.4901 37.3025 45.0569C41.7854 47.6231 46.9223 47.0843 48.7747 43.855C50.6283 40.6237 48.4953 35.926 44.0129 33.3588C39.5278 30.7941 34.3931 31.3314 32.538 34.5605Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.819 80.1965C140.819 114.607 120.442 142.502 86.0001 142.502C51.5571 142.502 31.1797 114.607 31.1797 80.1965C31.1797 45.7856 51.5571 17.8898 86.0001 17.8898C120.442 17.8898 140.819 45.7856 140.819 80.1965Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.803 75.8866C133.803 105.894 116.033 130.218 85.9997 130.218C55.966 130.218 38.1972 105.894 38.1972 75.8866C38.1972 45.8797 55.966 21.5566 85.9997 21.5566C116.033 21.5566 133.803 45.8797 133.803 75.8866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.397 74.2309C137.268 71.0654 137.729 67.767 137.729 64.3779C137.729 40.4058 114.681 20.9727 86.2502 20.9727C57.8193 20.9727 34.7715 40.4058 34.7715 64.3779C34.7715 68.2486 35.3724 72.0009 36.4998 75.5722C35.6379 78.5016 35.1825 81.553 35.1825 84.6877C35.1825 106.987 58.2303 125.065 86.6612 125.065C115.092 125.065 138.14 106.987 138.14 84.6877C138.14 81.0714 137.534 77.5661 136.397 74.2309Z",
    fill: "url(#paint0_radial_14011_164660)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.506 76.4372C109.506 73.4047 106.915 70.6607 102.727 68.6742C102.73 68.6422 102.737 68.6101 102.742 68.578C98.5491 66.5833 92.7517 65.3496 86.3471 65.3496C80.053 65.3496 74.3448 66.5417 70.1721 68.4747C70.1768 68.5092 70.1828 68.5436 70.1887 68.578C70.1828 68.5804 70.1768 68.5828 70.1721 68.5852C70.1721 68.5852 70.1721 68.5875 70.1733 68.5887C65.8793 70.5823 63.2124 73.3619 63.2124 76.4372C63.2124 82.4998 73.5746 87.4167 86.3578 87.4167H86.4755C92.8456 87.4167 98.6156 86.1949 102.799 84.2203C102.795 84.2049 102.787 84.1894 102.781 84.174C106.937 82.1887 109.506 79.4554 109.506 76.4372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.504 75.8932C109.504 81.9622 99.1417 86.8821 86.3593 86.8821C73.577 86.8821 63.2148 81.9622 63.2148 75.8932C63.2148 69.8242 73.577 64.9043 86.3593 64.9043C99.1417 64.9043 109.504 69.8242 109.504 75.8932Z",
    fill: "url(#paint1_linear_14011_164660)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1572 83.6701C74.3375 85.6451 80.1044 86.8653 86.4756 86.8653C92.8468 86.8653 98.6136 85.6451 102.794 83.6701C100.2 77.2168 93.8667 72.6504 86.4756 72.6504C79.0845 72.6504 72.751 77.2168 70.1572 83.6701Z",
    fill: "url(#paint2_radial_14011_164660)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.8794 77.8048C93.8794 80.0833 90.352 81.9297 86.001 81.9297C81.6489 81.9297 78.1203 80.0833 78.1203 77.8048C78.1203 75.5263 81.6489 73.6799 86.001 73.6799C90.352 73.6799 93.8794 75.5263 93.8794 77.8048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3472 64.9072C80.0543 64.9072 74.3449 66.0993 70.1733 68.0324C70.4443 70.2681 72.3494 72.0005 74.6586 72.0005H98.2687C100.543 72.0005 102.426 70.3216 102.742 68.1357C98.5504 66.1421 92.7531 64.9072 86.3472 64.9072Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3555 64.9072C80.5344 64.9072 75.2564 65.717 71.3975 67.5052C71.6482 69.5724 73.4024 71.2157 75.5393 71.2157H97.3738C99.4786 71.2157 101.224 69.6151 101.516 67.5942C97.6412 65.7491 92.2788 64.9072 86.3555 64.9072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3472 66.5456C92.5011 66.5456 98.0893 67.6867 102.235 69.5437C102.487 69.0818 102.664 68.5701 102.742 68.0263C98.5504 66.0327 92.7531 64.7979 86.3472 64.7979C80.0531 64.7979 74.3449 65.99 70.1733 67.9242C70.2387 68.4739 70.4051 68.9916 70.6499 69.4618C74.7763 67.6523 80.286 66.5456 86.3472 66.5456Z",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4258 51.6123C76.4258 58.8006 70.5928 64.627 63.3978 64.627C56.2028 64.627 50.371 58.8006 50.371 51.6123C50.371 44.424 56.2028 38.5965 63.3978 38.5965C70.5928 38.5965 76.4258 44.424 76.4258 51.6123Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.348 51.9859C122.348 59.1754 116.515 65.0029 109.318 65.0029C102.124 65.0029 96.2929 59.1754 96.2929 51.9859C96.2929 44.7976 102.124 38.9713 109.318 38.9713C116.515 38.9713 122.348 44.7976 122.348 51.9859Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.138 38.5596C102.138 47.2107 95.1179 54.2256 86.4552 54.2256C77.7972 54.2256 70.7769 47.2107 70.7769 38.5596C70.7769 29.9085 77.7972 22.8936 86.4552 22.8936C95.1179 22.8936 102.138 29.9085 102.138 38.5596Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6685 51.6123C74.6685 57.8294 69.6234 62.8721 63.3982 62.8721C57.1742 62.8721 52.1304 57.8294 52.1304 51.6123C52.1304 45.3941 57.1742 40.355 63.3982 40.355C69.6234 40.355 74.6685 45.3941 74.6685 51.6123Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.939 51.6118C73.939 57.4272 69.2202 62.1415 63.3994 62.1415C57.5786 62.1415 52.8599 57.4272 52.8599 51.6118C52.8599 45.7964 57.5786 41.082 63.3994 41.082C69.2202 41.082 73.939 45.7964 73.939 51.6118Z",
    fill: "url(#paint3_radial_14011_164660)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0654 51.6142C69.0654 54.7423 66.5272 57.2781 63.3962 57.2781C60.2651 57.2781 57.7269 54.7423 57.7269 51.6142C57.7269 48.486 60.2651 45.9502 63.3962 45.9502C66.5272 45.9502 69.0654 48.486 69.0654 51.6142Z",
    fill: "url(#paint4_radial_14011_164660)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0513 51.6125C66.0513 53.0753 64.8628 54.2627 63.3986 54.2627C61.9333 54.2627 60.746 53.0753 60.746 51.6125C60.746 50.1497 61.9333 48.9623 63.3986 48.9623C64.8628 48.9623 66.0513 50.1497 66.0513 51.6125Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.3746,
    cy: 49.1884,
    rx: 3.15633,
    ry: 2.42184,
    fill: "url(#paint5_linear_14011_164660)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.588 51.9887C120.588 58.2058 115.543 63.2461 109.319 63.2461C103.095 63.2461 98.0503 58.2058 98.0503 51.9887C98.0503 45.7705 103.095 40.729 109.319 40.729C115.543 40.729 120.588 45.7705 120.588 51.9887Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.858 51.9884C119.858 57.8037 115.14 62.5179 109.319 62.5179C103.498 62.5179 98.7798 57.8037 98.7798 51.9884C98.7798 46.1732 103.498 41.459 109.319 41.459C115.14 41.459 119.858 46.1732 119.858 51.9884Z",
    fill: "url(#paint6_radial_14011_164660)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.99 51.9878C114.99 55.1162 112.452 57.6523 109.32 57.6523C106.189 57.6523 103.65 55.1162 103.65 51.9878C103.65 48.8593 106.189 46.3232 109.32 46.3232C112.452 46.3232 114.99 48.8593 114.99 51.9878Z",
    fill: "url(#paint7_radial_14011_164660)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.97 51.9877C111.97 53.4505 110.784 54.6367 109.32 54.6367C107.855 54.6367 106.667 53.4505 106.667 51.9877C106.667 50.5249 107.855 49.3387 109.32 49.3387C110.784 49.3387 111.97 50.5249 111.97 51.9877Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.308,
    cy: 49.1884,
    rx: 3.15633,
    ry: 2.42184,
    fill: "url(#paint8_linear_14011_164660)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.345 38.5586C100.345 46.2753 94.0815 52.5303 86.36 52.5303C78.6338 52.5303 72.3729 46.2753 72.3729 38.5586C72.3729 30.842 78.6338 24.587 86.36 24.587C94.0815 24.587 100.345 30.842 100.345 38.5586Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4389 38.5588C99.4389 45.7758 93.5828 51.6264 86.3591 51.6264C79.1353 51.6264 73.2793 45.7758 73.2793 38.5588C73.2793 31.3418 79.1353 25.4912 86.3591 25.4912C93.5828 25.4912 99.4389 31.3418 99.4389 38.5588Z",
    fill: "url(#paint9_radial_14011_164660)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.3958 38.5583C93.3958 42.4408 90.2455 45.5883 86.3593 45.5883C82.4731 45.5883 79.3228 42.4408 79.3228 38.5583C79.3228 34.6757 82.4731 31.5283 86.3593 31.5283C90.2455 31.5283 93.3958 34.6757 93.3958 38.5583Z",
    fill: "url(#paint10_radial_14011_164660)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6514 38.5589C89.6514 40.3744 88.1777 41.8467 86.3605 41.8467C84.541 41.8467 83.0685 40.3744 83.0685 38.5589C83.0685 36.7434 84.541 35.2699 86.3605 35.2699C88.1777 35.2699 89.6514 36.7434 89.6514 38.5589Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.3625,
    cy: 35.0851,
    rx: 3.91671,
    ry: 3.00792,
    fill: "url(#paint11_linear_14011_164660)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14011_164660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.4557 67.7454) rotate(90) scale(62.8261 74.9963)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224916,
    stopColor: "#E4E4E4",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521135,
    stopColor: "#C530B6",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14011_164660",
    x1: 63.0393,
    y1: 86.8044,
    x2: 63.0984,
    y2: 64.7836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14011_164660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.4754 79.758) scale(12.5913 5.48416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF721B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1622"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_14011_164660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.3991 51.6121) scale(10.5395 10.5297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_14011_164660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.3974 51.6129) scale(5.66925 5.66397)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A4E1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14011_164660",
    x1: 63.3803,
    y1: 46.7666,
    x2: 63.3803,
    y2: 49.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_14011_164660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.32 51.9879) scale(10.5393 10.5294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_14011_164660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.32 51.9876) scale(5.66982 5.66454)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A4E1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14011_164660",
    x1: 109.313,
    y1: 46.7666,
    x2: 109.313,
    y2: 49.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_14011_164660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.3595 38.5584) scale(13.0798 13.0676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_14011_164660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.3592 38.5584) scale(7.03653 7.02997)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A4E1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14011_164660",
    x1: 86.3696,
    y1: 32.0771,
    x2: 86.3696,
    y2: 35.0232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14011_164660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 173,
    height: 147,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsterHandsUp2);
export default __webpack_public_path__ + "static/media/MonsterHandsUp2.794c5ffa7a9ae7a55bd548a3fa5026a6.svg";
export { ForwardRef as ReactComponent };